import { Injectable } from '@angular/core';
import { ApiInterface, ApiQueryParamsDTO } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  PessoaDTO,
  PessoaResponseDTO,
  RelatorioFinanceiro,
} from '../../models/clientes/pessoa.model';

@Injectable({
  providedIn: 'root',
})
export class PessoaService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: ApiQueryParamsDTO): Observable<PessoaResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PessoaResponseDTO>(patch);
  }

  getPessoasValores<T>(
    url: string,
    data?: ApiQueryParamsDTO
  ): Observable<RelatorioFinanceiro[]> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<RelatorioFinanceiro[]>(patch);
  }

  getById<T>(url: string, id: string): Observable<PessoaDTO> {
    return this.apiService.read<PessoaDTO>(`${url}/${id}`);
  }

  post<T>(url: string, data: PessoaDTO): Observable<PessoaDTO> {
    return this.apiService.create<PessoaDTO>(url, data);
  }

  put<T>(url: string, data: PessoaDTO): Observable<PessoaDTO> {
    return this.apiService.update<PessoaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  /**
   * Busca pessoa por RUC na API externa (via proxy no backend).
   * O backend faz a chamada a https://avatiapiruc.avatisistemas.com/pessoa/{ruc} (propriedade api-ruc.url) e retorna o resultado.
   */
  buscarPessoaPorRucExterno(rucBase: string): Observable<any> {
    return this.apiService.read(`/pessoas/buscarRucExterno/${rucBase}`);
  }
}
